import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "34.756",
  width: "50",
  viewBox: "0 0 50 34.756",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M0 .003V34.76h50V.002H0zM43.343 3.56L25 17.585 6.606 3.56h36.737zM3.557 5.745L18.14 17.23 3.557 28.712V5.745zM6.2 31.202l15.09-11.534 3.66 2.896 3.607-2.845 14.99 11.43H6.2zm40.243-2.286L31.707 17.33 46.443 5.745v23.17z"
  })]
});